import { Component } from '@angular/core';
import { MenuComponentBase } from '../../../../shared/base-classes/menu-component-base';
import { UsersListComponent } from '../users-list/users-list.component';

@Component({
  selector: 'app-manage-users',
  standalone: true,
  imports: [UsersListComponent],
  templateUrl: './manage-users.component.html',
  styleUrl: './manage-users.component.scss',
})
export class ManageUsersComponent extends MenuComponentBase {}
